<template>
    <div class="entete">
        <div class="headerPdf">
              <div class="headerLeft">
                 
                  <div style="display:inline-block;width: 60px;">  
                      <vue-qrcode :value="linkClub" :color="{ dark: '#000000', light:'#ffffff' }" />
                  </div>
                  <div  class="cartoucheClub">
                          <div> {{club.name}} </div>
                          
                          <div> {{club.tel}} </div>
                    </div>
                    
                    
              </div>
              <div class="headerCenter">
                 <div >
                    <img-file 
                        :ref="'F'+club.id" 
                        :pathFile="pathFile" 
                        width="60px" 
                        height="100%" role="player"
                        :upload="false"
                        :exists="club.logo ? true : false"/>
                 </div>
                  <div class="cartoucheTournoi" >
                    Concours du {{formatDate(tournoi.date)}} à {{tournoi.heure}} 
                    <div>
                    <s-fil :options="tournoi.options"/>
                        </div>
                      
                      <span>Feuille vierge des joueurs</span>
                  </div>
                      
              </div>
              <div class="headerRight">
                 <div style="text-align:right">
                    {{date}}  -  <b>{{indexPagination+1}} / {{classement.length}}</b>
                  </div>
                 
                 <div style="display:inline-block">
                  <section class="image-container" >
                    <img src="../../../assets/logo.png" class="user-image"  />
                  </section>
                  </div>
              </div> 
              </div>
      
        <div class="linkClub"><a :href="'//'+linkClub">{{linkClub}}</a></div>
              <div class="lignePdf headerResultat" v-show="mode!=2">
                <div class="nom">Nom</div>
                <div v-show="mode==1">Numéro</div>
                <div class="partie">Partie 1</div>
                <div class="partie">Partie 2</div>
                <div class="partie">Partie 3</div>
                <div class="partie">Partie 4</div>
              </div>
    </div>
</template>

<style  scoped>
  .headerPdf {
    width: 100%;
    display: flex;
    height: 70px;
    
  }
  .headerLeft {
    width: 25%;
    text-align: left;
  }
  .headerCenter {
    width: 50%;
  
   display: flex;
    
  }
  .headerRight{
    width: 25%;
    padding-right: 20px;
    text-align: right;
    font-size: 12px;
  }
  .today {
    font-style: italic;
    font-size: 12px;
    margin-top: -10px;
    margin-bottom: 10px;
    float: left;
  }
 
  
  .cartoucheClub {
    color: var(--bluebg);
    font-weight: bolder;
    height: 50px;
    margin-top: 0px;
    display: inline-block;
    vertical-align: top;
    text-align: center;
    font-size: 12px;
  }
  .cartoucheClub a {
     color: var(--bluebg);
        font-weight: bolder;
  }
  .cartoucheTournoi {
    color: black;
    font-weight: bolder;
    font-size: 12px;
    display: inline-block;
    text-align:center;
    margin-left: 40px;
  }
  .image-container {
      width: 110px;
      height: 60px;
      overflow: hidden;
      position: relative;
      margin-right: 25px;
      
    }
    .image-containerLogo {
      width: 400px;
     
      overflow: hidden;
      position: relative;
      margin-right: 25px;
      text-align: right;
      
    }
    .user-image {
        width: 100%;
       
    }
    .headerResultat {
      font-size: 20x;
      font-weight: bolder;
      
    }
     .linkClub {
      color: var(--bluebg);
      height: 20px;
    }
    .linkClub a {
      color: var(--bluebg);
      font-weight: bolder;
      font-size: 12px;
      text-align: left;
    }
  .lignePdf div.goal {
    width: 120px;
  } 
  .lignePdf div {
    display: inline-block;
    width: 75px;
    text-align:center;
    color: black;
    
  }
  .lignePdf div.nom {
    display: inline-block;
    width: 300px;
    text-align:center;
     color: black;
     font-weight: bolder;
  }
  .lignePdf div.partie {
    display: inline-block;
    width: 120px;
    text-align:center;
     color: black;
     font-weight: bolder;
  }
  .lignePdf div.goalParties {
    width: 200px;
    
  }
</style>
<script>
import imgFile from '@/components/imgStore.vue'
import VueQrcode from 'vue-qrcode'
export default {
    props: ["classement", "tournoi", "club", "indexPagination", "date", "resultat", "mode", "title"],
    components: {
     imgFile,
     VueQrcode
    },
    computed: {
    
  
      linkClub() {
        return "www.petanque-app.com/club/" + this.club.id;
      },
       pathFile() {
        if (this.club.length!=0) {
              var url = '/club/'+this.club.id;
              return url;
          }
          return null;
      },
   },
   methods: {
     
    formatDate(date) {
            var options = { year: "2-digit", month: "2-digit", day: "2-digit"};
            return (new Date(date)).toLocaleString("fr-Fr",options);
    },
   }
}
</script>
